import { Pipe, PipeTransform } from '@angular/core';
import { AccessRestrictionEnum } from '@shared/core/enums/access-restriction.enum';

@Pipe({
  name: 'accessRestriction',
})
export class AccessRestrictionPipe implements PipeTransform {
  transform(value: AccessRestrictionEnum, defaultValue: string = '-'): string {
    switch (value) {
      case AccessRestrictionEnum.NONE:
        return 'shipment_details.access_restriction.none';
      case AccessRestrictionEnum.ONLY_SMALL_TRUCKS:
        return 'shipment_details.access_restriction.only_small_trucks';
      case AccessRestrictionEnum.ONLY_MW:
        return 'shipment_details.access_restriction.only_mw';
      default:
        return defaultValue;
    }
  }
}
